import S from 's-js';

/**
 * A "reducing" signal which takes its updates in the form of a transform function and allows for the
 * possibility that multiple transforms might be applied in a single tick of S's clock.
 */
export interface SumSignal<T> {
    (update? : (value : T) => T) : T;
}

/**
 * Returns a "reducing" signal which takes its updates in the form of a transform function and allows for the
 * possibility that multiple transforms might be applied in a single tick of S's clock.
 * @param value The intial value
 */
export function sumSignal<T>(value : T) : SumSignal<T> {
    const
        // A pure event signal
        ev = S.data(null),
        // Distinguish the pending value that's being operated on by any provided update functions from the
        // comitted value that will be exposed to code reading from the signal. If the signal is updated while
        // S's clock is already frozen, we don't wanna expose the pending value to signal readers till after
        // S's clock ticks.
        committedValue = S.root(() => S.on(ev, () => value));
    return update => {
        if (update === undefined) {
            return committedValue();
        } else {
            // Update pending value...
            value = update(value);
            // ...then notify S that the value is changing. It's important to notify second in case this update
            // happens while S's clock is unfrozen.
            ev(null);
            return value;
        }
    };
}



// WEBPACK FOOTER //
// ./lib/sumSignal.ts